<template>
        <!-- <v-container pa-2 grid-list-md> -->
            <v-card class="mx-auto" width="100%">
                <v-img
                    class="teal--text text--lighten-4 align-begin"
                    :height="imgHeight"
                    src="@/assets/info.jpg"
                    gradient="to bottom, rgba(0,0,0,.3), rgba(0,0,0,1)"
                >
                    <v-card-title>Caso {{ caseNumber }} - Introducción</v-card-title>
                    <v-divider class="teal lighten-3"></v-divider>
                    <v-card-text class="subtitle-1">
                        {{ caseIntro }}
                    </v-card-text>
                </v-img>

                
            </v-card>
        <!-- </v-container> -->
    
    
</template>
<script>
import { mapGetters } from 'vuex';

export default {
    name: 'CaseIntroduction',
    data() {
        return {};
    },
    created() {},
    props: {
        caseNumber: Number,
        caseIntro: String
    },
    methods: {
        
    },
    computed: {
        ...mapGetters(['waitCursor']),

        imgHeight() {
            var height;
            if (this.$vuetify.breakpoint.xs) {
                height = '200px';
            } else if (this.$vuetify.breakpoint.sm) {
                height = '250px';
            } else {
                height = '300px';
            }
            return height;
        },
        
    }
};
</script>
